import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

export type AdjustmentReasonItem = Omit<AdjustmentReasonInternalItem, 'version'>;

type AdjustmentReasonInternalItem = {
    readonly version: string;
    readonly id: number;
    readonly default: boolean;
    readonly name: string;
};

export class AdjustmentReasonCollectionQuery extends Query<AdjustmentReasonItem[]> { }

export class AdjustmentReasonCollectionQueryHandlerBase implements QueryHandler<AdjustmentReasonCollectionQuery> {
    private static Url = TaggedUrl.join('sales/adjustmentReasons', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: AdjustmentReasonCollectionQuery): Promise<AdjustmentReasonItem[]> {
        const { data: { items } } = await this.http.get<{ items: AdjustmentReasonInternalItem[]; }>(AdjustmentReasonCollectionQueryHandlerBase.Url);
        return items.map(i => ({
                id: i.id,
                default: i.default,
                name: i.name
        }));
    }
}
